import React from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import MarketingPage from "./MarketingPage/MarketingPage";
import { ThemeProvider } from "@mui/material";
import { theme } from "./Theme/theme";
import { AdmissionFormPage } from "./AdmissionForm/AdmissionFormPage";

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <div className="root" id="root">
          <Router>
            <Routes>
              <Route path="/" element={<MarketingPage />} />
              <Route path="/admission" element={<AdmissionFormPage />} />
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          </Router>
        </div>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
